import React from "react";
import "./styles/metricsSection.css";
import MetricsCard from "../../../../components/MetricsCard/MetricsCard";
import { useSelector } from "react-redux";

const MetricsSection = () => {
  const { weight, height, preferences } = useSelector(
    (state) => state.userReducer
  );
  const { routesCompleted } = useSelector((state) => state.routeReducer);
  return (
    <div className="metrics-section">
      <MetricsCard
        title="Rutas Completas"
        value={`${routesCompleted ?? 0} Rutas`}
        titleTooltip="Rutas que has completado."
      />
      <MetricsCard
        title="Terreno"
        value={`${preferences?.terreno ?? "Pista"} `}
        titleTooltip="Tipo de terreno preferido."
      />
      <MetricsCard
        title="Distancia"
        value={`${preferences?.distancia ?? "2-5 km"}`}
        titleTooltip="Distancia preferida para correr."
      />
      <MetricsCard title="Altura" value={`${height ?? 0} mts`} />
      <MetricsCard title="Peso" value={`${weight ?? 0} kg`} />
    </div>
  );
};

export default MetricsSection;
